import {
    Text,
    View,
    StyleSheet,
} from '@react-pdf/renderer';

import { getPageNumberInPDF } from '../report/utils/reportString';

const footerStyles = StyleSheet.create({
    footer: {
        position: 'absolute',
        fontFamily: 'Roboto',
        bottom: 20,
        left: 20,
        right: 20,
        height: 32,
        display: 'flex',
        justifyContent: 'flex-end',
        borderTopStyle: 'solid',
        borderTopWidth: 1,
        borderTopColor: '#E6E6E6',
    },
    footerName: {
        position: 'absolute',
        fontFamily: 'Roboto',
        fontWeight: 400,
        fontSize: 10,
        bottom: 0,
        left: 0,
        color: '#636363',
    },
    footerPage: {
        position: 'relative',
        fontFamily: 'Roboto',
        fontWeight: 400,
        fontSize: 10,
        marginLeft: 'auto',
        marginRight: 'auto',
        color: '#636363',
    },
    footerURL: {
        position: 'absolute',
        fontFamily: 'Roboto',
        fontWeight: 400,
        fontSize: 10,
        bottom: 0,
        right: 0,
        color: '#636363',
    },
});

const ReportPDFPageFooter = () => {
    return (
        <View style={footerStyles.footer} fixed>
            <Text style={footerStyles.footerName}>© BRT Systems Pte Ltd.</Text>
            <Text
                style={footerStyles.footerPage}
                render={getPageNumberInPDF}
            />
            <Text style={footerStyles.footerURL}>www.brtsys.com</Text>
        </View>
    );
};

export default ReportPDFPageFooter;
